var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    { staticClass: "primary-nav__list", attrs: { id: "bic-search-menu" } },
    [
      _c(
        "li",
        {
          staticClass: "primary-nav__item",
          class: { "primary-nav__item--current": _vm.mode === "default" },
        },
        [
          _c(
            "router-link",
            { staticClass: "primary-nav__link", attrs: { to: "/" } },
            [_vm._v("Home")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "primary-nav__item",
          class: { "primary-nav__item--current": _vm.mode === "browse" },
        },
        [
          _c(
            "router-link",
            {
              staticClass: "primary-nav__link",
              attrs: { to: "/browse/class" },
            },
            [_vm._v("Browse for a code")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "primary-nav__item",
          class: { "primary-nav__item--current": _vm.mode === "search" },
        },
        [
          _c(
            "router-link",
            { staticClass: "primary-nav__link", attrs: { to: "/search" } },
            [_vm._v("Search for a code")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }